import { z } from "zod";

export type PurchaseOrderVarianceDecision = "needs_decision" | "accepted" | "disputed";
export interface PurchaseOrderVarianceAmount { currency: string; amount: string }
export interface PurchaseOrderVarianceOrder {
  purchaseOrderId: string;
  purchaseOrderNumber: string;
  purchaseOrderStatus: string;
  vendorId: string | null;
  vendorName: string | null;
  orderCurrency: string;
  orderedAmount: string;
  invoicedAmounts: PurchaseOrderVarianceAmount[];
  differenceAmount: string | null;
  hasVariance: boolean;
  invoiceNumbers: string[];
  unmatchedLineCount: number;
  differingLineCount: number;
  creditedAmount: string;
  fingerprint: string;
  decision: PurchaseOrderVarianceDecision;
  decidedByName: string | null;
  decidedAt: string | null;
  decisionReason: string | null;
}
export interface PurchaseOrderVarianceOrderResponse {
  orders: PurchaseOrderVarianceOrder[];
  needsDecisionCount: number;
}
export interface PurchaseOrderVarianceDetailLine {
  id: string;
  invoiceNumber: string;
  description: string;
  partNumber: string | null;
  currency: string;
  quantity: string | null;
  orderedAmount: string | null;
  invoicedAmount: string;
  differenceAmount: string | null;
  hasVariance: boolean;
  varianceReason: string | null;
}
export interface PurchaseOrderVarianceDetailResponse {
  order: PurchaseOrderVarianceOrder;
  lines: PurchaseOrderVarianceDetailLine[];
}
export const purchaseOrderVarianceDecisionBody = z.object({
  decision: z.enum(["accepted", "disputed"]),
  reason: z.string().trim().max(2000).optional(),
  fingerprint: z.string().min(1).max(200),
  idempotencyKey: z.string().min(8).max(200),
}).superRefine((body, context) => {
  if (body.decision === "disputed" && !body.reason?.trim()) {
    context.addIssue({ code: "custom", path: ["reason"], message: "Enter the question to ask the vendor." });
  }
});
